import { useMutation, useQuery } from '@apollo/client/react'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'
import { GQL_MY_ACCOMMODATION, GQL_SUBMIT_ACCOMMODATION, GQL_WITHDRAW_ACCOMMODATION } from '~/gql/accommodations/accommodations'

/** La demande d'aménagement de l'apprenant (#327) : la lire, l'envoyer, la retirer. */
export function useAccommodation(onDone: () => void) {
  const { t } = useTranslation()
  const { data } = useQuery(GQL_MY_ACCOMMODATION, { fetchPolicy: 'cache-and-network' })
  const refetch = { refetchQueries: [GQL_MY_ACCOMMODATION], awaitRefetchQueries: true }
  const [submit, submitting] = useMutation(GQL_SUBMIT_ACCOMMODATION, refetch)
  const [withdraw, withdrawing] = useMutation(GQL_WITHDRAW_ACCOMMODATION, refetch)

  const run = async (write: () => Promise<unknown>, success: string) => {
    try {
      await write()
      toast.success(t(success))
      onDone()
    } catch {
      toast.error(t('accommodation.failed'))
    }
  }

  return {
    accommodation: data?.myAccommodation,
    busy: submitting.loading || withdrawing.loading,
    submit: (needs: string) => run(() => submit({ variables: { input: { needs, consent: true } } }), 'accommodation.sent'),
    withdraw: () => run(() => withdraw(), 'accommodation.withdrawn'),
  }
}
